"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlacementFlow = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _types = require("./types");
var _useDropdownPlugins = require("./hooks/useDropdownPlugins");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const ACTION_TYPES = {
  SELECT_ENTITY_TYPE: "SELECT_ENTITY_TYPE",
  SELECT_ENTITY: "SELECT_ENTITY",
  ASSOCIATE_ENTITY: "ASSOCIATE_ENTITY",
  RESET_TO_INITIAL: "RESET_TO_INITIAL"
};
const selectEntityTypeAction = entityType => ({
  type: ACTION_TYPES.SELECT_ENTITY_TYPE,
  entityType
});
const selectEntityAction = entity => ({
  type: ACTION_TYPES.SELECT_ENTITY,
  entity
});
const associateEntityAction = () => ({
  type: ACTION_TYPES.ASSOCIATE_ENTITY
});
const resetToInitialAction = () => ({
  type: ACTION_TYPES.RESET_TO_INITIAL
});
const initialState = {
  status: _types.PlacementFlowStatus.NOTHING_SELECTED
};
const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SELECT_ENTITY_TYPE:
      return {
        ...state,
        status: _types.PlacementFlowStatus.ENTITY_TYPE_SELECTED,
        entityType: action.entityType
      };
    case ACTION_TYPES.SELECT_ENTITY:
      return {
        ...state,
        status: _types.PlacementFlowStatus.ENTITY_SELECTED,
        // @ts-ignore
        entity: action.entity
      };
    case ACTION_TYPES.ASSOCIATE_ENTITY:
      return {
        ...state,
        status: _types.PlacementFlowStatus.ENTITY_ASSOCIATED
      };
    case ACTION_TYPES.RESET_TO_INITIAL:
      return initialState;
    default:
      return state;
  }
};
const OPTIONS_ORDER = ["files", "sheets"];
const OptionContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n"])));
const usePlacementFlow = () => {
  const [state, dispatch] = (0, _react.useReducer)(reducer, initialState);
  const selectEntityType = (0, _react.useCallback)(entityType => dispatch(selectEntityTypeAction(entityType)), []);
  const selectEntity = (0, _react.useCallback)(entity => dispatch(selectEntityAction(entity)), []);
  const associateEntity = (0, _react.useCallback)(() => {
    if (window.location.hash) {
      window.history.back();
    }
    dispatch(associateEntityAction());
  }, []);
  const resetToInitial = (0, _react.useCallback)(() => {
    if (window.location.hash) {
      window.history.back();
    }
    return dispatch(resetToInitialAction());
  }, []);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    docsPlugin,
    sheetsPlugin
  } = (0, _useDropdownPlugins.useDropdownPlugins)();
  const selectMessage = T.translate("actions.select");
  const optionsByEntityType = (0, _react.useMemo)(() => ({
    files: {
      type: "files",
      plugin: {
        ...docsPlugin,
        AddRelationshipsButtonText: () => {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectMessage);
        }
      },
      iconComponent: _alloyReactIcon.DocumentTextIcon,
      panelTitle: T.translate("issueCreation.placement.fileSelectionPanelTitle"),
      name: T.translate("issueCreation.placement.files")
    },
    sheets: {
      type: "sheets",
      plugin: {
        ...sheetsPlugin,
        AddRelationshipsButtonText: () => {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectMessage);
        }
      },
      iconComponent: _alloyReactIcon.SheetsIcon,
      panelTitle: T.translate("issueCreation.placement.sheetSelectionPanelTitle"),
      name: T.translate("issueCreation.placement.sheets")
    }
  }), [T, docsPlugin, sheetsPlugin, selectMessage]);
  const getIconForEntityType = entityType => optionsByEntityType[entityType].iconComponent;
  const getNameForEntityType = entityType => optionsByEntityType[entityType].name;
  const dropdownOptions = (0, _react.useMemo)(() => OPTIONS_ORDER.map(entityType => {
    const LabelComponent = optionsByEntityType[entityType].plugin.PluralText;
    return {
      value: entityType,
      label: /*#__PURE__*/_react.default.createElement(LabelComponent, null)
    };
  }), [optionsByEntityType]);
  const selectedEntityTypeConfig = (0, _react.useMemo)(() => state.entityType && optionsByEntityType[state.entityType], [optionsByEntityType, state]);
  const optionRenderer = (0, _react.useCallback)(option => {
    const IconComponent = optionsByEntityType[option.value].iconComponent;
    return /*#__PURE__*/_react.default.createElement(OptionContainer, null, /*#__PURE__*/_react.default.createElement(IconComponent, {
      size: 20
    }), option.label);
  }, [optionsByEntityType]);
  return {
    selectEntityType,
    selectEntity,
    associateEntity,
    resetToInitial,
    dropdownOptions,
    optionRenderer,
    selectedEntityTypeConfig,
    entityType: state.entityType,
    entity: state.entity,
    status: state.status,
    getNameForEntityType,
    getIconForEntityType
  };
};
exports.usePlacementFlow = usePlacementFlow;
//# sourceMappingURL=usePlacementFlow.js.map